import {tap} from 'rxjs';
import {Component, HostListener, OnInit, signal, PLATFORM_ID, inject, ChangeDetectionStrategy, ChangeDetectorRef, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {isPlatformBrowser} from '@angular/common';
import {LoaderService} from "../../services/loader.service";
import {AuthService} from "../../services/auth.service";
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { FooterComponent } from '../include/footer/footer.component';
import { ContainerComponent } from '../../../components/container/container.component';
import { HeaderComponent } from '../include/header/header.component';
import { PreloaderComponent } from '../../../components/preloader/preloader.component';

import { ToastsComponent } from '../../../components/toasts/toasts.component';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToastsComponent, PreloaderComponent, HeaderComponent, ContainerComponent, RouterOutlet, FooterComponent]
})
export class MainLayoutComponent implements OnInit {
  loaderS = inject(LoaderService);
  private auth = inject(AuthService);
  private router = inject(Router);

  private readonly cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);


  /** Показывать кнопку «наверх» после прокрутки. */
  scrolled = signal(false);

  /** тип текущей навигации — imperative (клик) / popstate (назад) */
  private navTrigger?: 'imperative' | 'popstate' | 'hashchange';

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  @HostListener('window:scroll')
  onScroll(): void {
    if (this.isBrowser) {
      this.scrolled.set(window.scrollY > 400);
    }
  }

  scrollTop(): void {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.scrolled.set(window.scrollY > 400);
    }
    this.auth.isTokenExpired();

    this.router.events.pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({
      next: value => {
        if (value instanceof NavigationStart) {
          this.navTrigger = (value as NavigationStart).navigationTrigger;
        }
        if (value instanceof NavigationEnd) {
          this.auth.isTokenExpired();
          // scrollPositionRestoration у роутера включён, но на lazy-роутах
          // (courses и др.) иногда не срабатывает — подстраховка.
          // 'popstate' (кнопки назад/вперёд) и #якоря не трогаем.
          if (this.isBrowser
              && this.navTrigger === 'imperative'
              && !value.urlAfterRedirects.includes('#')) {
            window.scrollTo(0, 0);
          }
        }
      }

    });

  }


}
